var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStatusError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7131 13.9L10.833 1.98338C10.4504 1.32076 9.7652 0.92511 8.99999 0.92511C8.23482 0.92511 7.54955 1.32076 7.16698 1.98338L0.286954 13.9C-0.0956512 14.5626 -0.0956512 15.3539 0.286954 16.0165C0.669558 16.6792 1.35475 17.0748 2.11996 17.0748H15.88C16.6452 17.0748 17.3304 16.6792 17.7131 16.0166C18.0957 15.3539 18.0957 14.5626 17.7131 13.9ZM16.7998 15.4893C16.6078 15.8218 16.264 16.0203 15.88 16.0203H2.11996C1.73599 16.0203 1.39216 15.8218 1.20021 15.4893C1.00825 15.1568 1.00825 14.7598 1.20021 14.4273L8.08031 2.51069C8.27226 2.17818 8.61609 1.97969 9.00003 1.97969C9.38393 1.97969 9.72779 2.17818 9.91975 2.51069L16.7998 14.4273C16.9917 14.7598 16.9917 15.1568 16.7998 15.4893Z",
    fill: "#F44336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5272 6.18781H8.47266V11.4606H9.5272V6.18781Z",
    fill: "#F44336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99993 12.5153C8.61226 12.5153 8.29688 12.8306 8.29688 13.2183C8.29688 13.606 8.61226 13.9214 8.99993 13.9214C9.38756 13.9214 9.70298 13.606 9.70298 13.2183C9.70298 12.8306 9.38759 12.5153 8.99993 12.5153Z",
    fill: "#F44336"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusError);
export default __webpack_public_path__ + "static/media/status-error.f139a20ec9b6372ea4f1fdc14e256469.svg";
export { ForwardRef as ReactComponent };